export default __webpack_public_path__ + "3daa5b4ad6cd0792dce8a81d8fbb2f85.svg";